import { Component } from '@angular/core';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatCard } from '@angular/material/card';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'recrewt-info-card-layout',
  templateUrl: './info-card-layout.component.html',
  styleUrls: ['./info-card-layout.component.scss'],
  imports: [FlexModule, MatCard, RouterOutlet, FooterComponent],
})
export class InfoCardLayoutComponent {}
